import { IconCheckCircleFill, IconCloseCircleFill, IconSize } from "@amzn/stencil-react-components/icons";
import React from "react";
import { HVH_COLORS } from "../../config/palette";
import { StatusEnum } from "../../hoc/with-status";
import useArb from "../../hooks/use-arb";
import ProgressRing from "../screening-results/progress-ring.svg";
import { renderBGColor } from "../task/ui-redesign";
import { FlyOutStatusCard, bgcUseStatusText } from "../utilities/FlyOutStatusCard";
import { Card } from "@amzn/stencil-react-components/card";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import { H3, Text } from "@amzn/stencil-react-components/text";
import { Link } from "@amzn/stencil-react-components/link";

export interface RTWAppointmentProps {
  status: StatusEnum;
}

//Need to update the rtwAppointmentStatus and instructions based on the status
export const RTWAppointmentScheduleStatus = ({ status }: RTWAppointmentProps) => {
  // let rtwAppointmentStatus;
  // let instructions;

  const bundle = useArb("HVHChecklistPantherResource");

  const translatedStatus = bundle.getMessage("checklist-General-Status");
  const rtwDetailsMessageTitle = bundle.getMessage("Checklist-Flyout-RTW-Appointment-Details-Title");

  const rtwAppointmentAcceptableDocuments = bundle.getMessage(
    "Checklist-RTW-Appointment-Detail-Acceptable-documents-Message"
  );
  const requiredDocUrl = "https://www.google.com"; //update doc URL
  const requiredDoc = (
    <Link target="_blank" href={requiredDocUrl}>
      {rtwAppointmentAcceptableDocuments}
    </Link>
  );

  const rtwAppointmentDetailGeneralMessage = bundle.formatMessage("Checklist-RTW-Appointment-Detail-GeneralMessage", {
    requiredDocsLink: requiredDoc,
  });

  // const rtwAppointmentStatus = (

  // );
  // const instructions = (

  // );

  return (
    //still need to refactor the components based on status
    <Col padding={"1rem"} gridGap={"1rem"}>
      <Card padding={"0rem"}>
        <Col backgroundColor={renderBGColor(status)} width={"6px"} />
        <Col padding="S300" gridGap="S300">
          <H3 fontSize={"T400"}>{translatedStatus}</H3>
          <Text>{status}</Text>
        </Col>
      </Card>

      <Card padding={"0rem"}>
        <Col>
          <Col backgroundColor={renderBGColor(status)} width={"6px"} />
          <Col gridGap={"1rem"} padding={"1rem"}>
            <H3 fontSize={"T400"}>{rtwDetailsMessageTitle}</H3>
            <Text>{rtwAppointmentDetailGeneralMessage}</Text>
          </Col>
        </Col>
      </Card>
    </Col>
  );
};
